import { render, staticRenderFns } from "./Shipment.vue?vue&type=template&id=ab065e40&scoped=true"
import script from "./Shipment.vue?vue&type=script&lang=js"
export * from "./Shipment.vue?vue&type=script&lang=js"
import style0 from "./Shipment.vue?vue&type=style&index=0&id=ab065e40&prod&scoped=true&lang=scss"
import style1 from "./Shipment.vue?vue&type=style&index=1&id=ab065e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab065e40",
  null
  
)

export default component.exports